import React from 'react'

import {
  Box, ListItem, ToggleButton,
} from '@domain-group/suit-theme'

import Description from './Description'
import Title from './Title'

type ToggleListItemProps = {
  boxProps?: object,
  children: React.ReactNode,
  onClick?: Function,
  toggleOffText?: string,
  toggleOnText?: string,
  toggleValue: boolean,
}

const ToggleListItem = (props: ToggleListItemProps) => {
  const {
    boxProps, children, onClick, toggleOnText, toggleOffText, toggleValue, ...toggleProps
  } = props

  return (
    <ListItem
      boxProps={{
        fontSize: 'small',
        lineHeight: 1.3,
        marginBottom: 'large',
        ...boxProps,
      }}
      disableHover
    >
      <Box alignItems="center" justifyContent="space-between">
        {children && (
          <Box flexDirection="column" maxWidth="80%">
            {children}
          </Box>
        )}

        <ToggleButton
          onClick={onClick}
          toggleOn={toggleValue}
          toggleOnText={toggleOnText}
          toggleOffText={toggleOffText}
          {...toggleProps}
        />
      </Box>
    </ListItem>
  )
}

ToggleListItem.Description = Description
ToggleListItem.Title = Title

export default ToggleListItem
